// extracted by mini-css-extract-plugin
export default {"imgContainer":"AboutMe_imgContainer__eX0AC","title":"AboutMe_title__RH4kr","details":"AboutMe_details__1yll4","bottom":"AboutMe_bottom__jFWzI"};